import { render, staticRenderFns } from "./reality-check.vue?vue&type=template&id=97d2b8fc"
import script from "./reality-check.vue?vue&type=script&lang=js"
export * from "./reality-check.vue?vue&type=script&lang=js"
import style0 from "./reality-check.vue?vue&type=style&index=0&id=97d2b8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports